import { Validators } from '@angular/forms';
import { ButtonType, CrudFormConfig, CrudFormMonacoCodeEditorItem, CrudFormTextAreaItem, CrudFormTextBoxItem, CrudViewFormItemType, FormLayout } from '@rappider/rappider-components/utils';
import { PASCAL_CASE_REGEX } from '../../../definitions/regex';
import { POP_CONFIRM_DELETE_ACTION } from '../../pop-confirm-button/pop-confirm-button-config';

export const WORKFLOW_EVENT_CREATE_OR_EDIT_CONFIG: CrudFormConfig = {
  items: [
    <CrudFormTextBoxItem>{
      title: 'SHARED.NAME',
      fieldName: 'name',
      type: CrudViewFormItemType.TextBox,
      autoFocus: true,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        },
        {
          type: Validators.pattern(PASCAL_CASE_REGEX),
          errorKey: 'pattern',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.MUST_BE_PASCAL_CASE'
        }
      ],
      hint: 'Event name must be in PascalCase format. Example: MyEventName',
      showRequiredSign: true
    },
    <CrudFormTextAreaItem>{
      'title': 'Description',
      'type': CrudViewFormItemType.TextArea,
      'fieldName': 'description',
      'showRequiredSign': false,
      'default': null,
      'options': [],
      'inputComponentSize': {
        'xs': 24,
        'sm': 24,
        'md': 6,
        'lg': 4,
        'xxl': 3
      },
      minRows: 4,
      autosize: true,
      maxRows: 16,
      description: 'A brief description of the event. This will be displayed in the workflow diagram.',
    },
    <CrudFormMonacoCodeEditorItem>{
      title: 'Workflow Event Input Sample',
      fieldName: 'inputDataSample',
      type: CrudViewFormItemType.MonacoCodeEditor,
      editorOptions: {
        theme: 'vs',
        language: 'json',
        lineNumbers: { renderType: 0 },
        minimap: {
          enabled: false,
        },
      },
      sizeSettings: {
        minHeight: '300px'
      }
    }
  ],
  formLayout: FormLayout.Vertical,
  submitButton: {
    type: ButtonType.Primary
  },
  cancelButton: {
    type: ButtonType.Default,
    text: 'SHARED.DELETE',
    popconfirmTitle: 'Are you sure you want to delete these item ?',
    emitWithoutPopconfirm: false,
    behavior: POP_CONFIRM_DELETE_ACTION.behavior,
    icon: POP_CONFIRM_DELETE_ACTION.icon,
    popconfirmCancelText: POP_CONFIRM_DELETE_ACTION.popconfirmCancelText,
    popconfirmOkText: POP_CONFIRM_DELETE_ACTION.popconfirmOkText,
    popconfirmOkDanger: POP_CONFIRM_DELETE_ACTION.popconfirmOkDanger,
  }
};

export const workflowEventDeleteAllWorkflowButtonConfig = {
  text: 'Delete All Steps',
  name: POP_CONFIRM_DELETE_ACTION.name,
  popconfirmTitle: 'Are you sure? You are going to delete all this steps',
  emitWithoutPopconfirm: POP_CONFIRM_DELETE_ACTION.emitWithoutPopconfirm,
  behavior: POP_CONFIRM_DELETE_ACTION.behavior,
  popconfirmCancelText: POP_CONFIRM_DELETE_ACTION.popconfirmCancelText,
  popconfirmOkText: POP_CONFIRM_DELETE_ACTION.popconfirmOkText,
  popconfirmOkDanger: POP_CONFIRM_DELETE_ACTION.popconfirmOkDanger,
  colorType: 'danger',
  content: 'Use this button to delete the event and all related workflows'
}

export const workflowEventDeleteFollowingStepsButtonConfig = {
  text: 'Delete Following Steps',
  name: POP_CONFIRM_DELETE_ACTION.name,
  popconfirmTitle: 'Are you sure? You are going to delete this event and following steps',
  emitWithoutPopconfirm: POP_CONFIRM_DELETE_ACTION.emitWithoutPopconfirm,
  behavior: POP_CONFIRM_DELETE_ACTION.behavior,
  popconfirmCancelText: POP_CONFIRM_DELETE_ACTION.popconfirmCancelText,
  popconfirmOkText: POP_CONFIRM_DELETE_ACTION.popconfirmOkText,
  popconfirmOkDanger: POP_CONFIRM_DELETE_ACTION.popconfirmOkDanger,
  colorType: 'danger',
  content: 'Use this button to delete the event and following steps'
}
